import "./Cart.module.css";
import TheEssenceHeader from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import TheBoutiqueFooter from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <TheEssenceHeader />
      <CartContent />
      <TheBoutiqueFooter />
    </div>;
}